/**
 *  Component: Installation Section
 */
import React from 'react';

import { StyledTypography } from 'styles/common';

import { Download1Icon } from 'constants/icons';

import { BodyContainer, FormContainer, FormHeading, Separator, Icon } from '../styles';

const Item = ({ children, isTopItem = false }) => (
  <StyledTypography bottomGutter={1} topGutter={isTopItem ? 1 : 0}>
    {children}
  </StyledTypography>
);

const InstallationSection = () => (
  <FormContainer>
    <FormHeading>
      <Icon>
        <Download1Icon size="fixed16px" />
      </Icon>
      Installation Steps
    </FormHeading>
    <Separator />
    <BodyContainer>
      <Item isTopItem>
        1. Click <strong>Get</strong> to get redirected to Mesh app for Jira.
      </Item>
      <Item>
        2. Log into your Jira instance <strong>as an admin.</strong>
      </Item>
      <Item>3. Fill in your "connection name & URL" in the link settings panel on top of this page</Item>
    </BodyContainer>
  </FormContainer>
);

export default InstallationSection;
